"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var tempListApi = _interopRequireWildcard(require("@/api/tempListApi.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      tempSettingActive: '1',
      pram: {},
      stationLetter: {
        content: '',
        enabled: false
      },
      sms: {
        tencent_template_code: null,
        aliyun_template_code: null,
        content: '',
        aliyun_content: '',
        enabled: false
      },
      wechat: {
        template_code: null,
        template_id: null,
        content: '',
        enabled: false
      },
      lark: {
        content: '',
        enabled: false
      },
      email: {
        content: '',
        enabled: false
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit(tagDetails) {
      var _ref = (tagDetails === null || tagDetails === void 0 ? void 0 : tagDetails.notifications) || {},
        _ref$stationLetter = _ref.stationLetter,
        stationLetter = _ref$stationLetter === void 0 ? {} : _ref$stationLetter,
        _ref$sms = _ref.sms,
        sms = _ref$sms === void 0 ? {} : _ref$sms,
        _ref$wechat = _ref.wechat,
        wechat = _ref$wechat === void 0 ? {} : _ref$wechat,
        _ref$lark = _ref.lark,
        lark = _ref$lark === void 0 ? {} : _ref$lark,
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? {} : _ref$email;
      this.tempSettingActive = '1';
      this.pram = _objectSpread({}, tagDetails);
      this.stationLetter = _objectSpread({
        content: '',
        enabled: false
      }, stationLetter);
      this.lark = _objectSpread({
        content: '',
        enabled: false
      }, lark);
      this.sms = _objectSpread(_objectSpread({
        content: '',
        aliyun_content: '',
        enabled: false
      }, sms), {}, {
        tencent_template_code: sms.tencent_template_code || null,
        aliyun_template_code: sms.aliyun_template_code || null
      });
      this.wechat = _objectSpread({
        template_code: null,
        template_id: null,
        content: '',
        enabled: false
      }, wechat);
      this.email = _objectSpread({
        content: '',
        enabled: false
      }, email);
      this.visible = true;
    },
    handerSubmit: function handerSubmit() {
      var _this2 = this;
      this.$refs['temppramRef'].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        tempListApi.saveTemplateSettings(_objectSpread(_objectSpread({}, _this2.pram), {}, {
          notifications: {
            stationLetter: _this2.stationLetter,
            sms: _this2.sms,
            wechat: _this2.wechat,
            lark: _this2.lark,
            email: _this2.email
          }
        })).then(function (data) {
          _this2.visible = false;
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.pram[dataIndex] = img[0].sattDir;
      }, tit, 'system');
    }
  }
};